export const FS_TOPIC = 'focusSession'
